<!-- NOVA Date Range Picker - Simplified for debugging -->
<div class="datepicker-class nova-datepicker-class" [class.nova-open-upward]="openUpward">
  <div class="row nova-daterange-picker-row mt-3 mb-3">
    <div class="col-12 datepicker-trigger-row" style="display: flex; flex-direction: row; position: relative;"
      [class.nova-trigger-wrapper]="openUpward"
      (click)="onTriggerClick($event)">

      <!-- Always show the button for now -->
      <div class="button-wrapper" [ngStyle]="openUpward ? null : { width: divWidthTop }">
        <app-button iconUrl="assets/icons/date_range.svg" (onButtonClick)="toggleDropdown()"
          [buttonText]="getDateLabel()" [clicked]="_dropdownOpened()"></app-button>
      </div>

      <input #novaDatePickerInput [ngStyle]="openUpward ? null : { width: divWidthBottom }" class="nova-daterangepicker-input rangepicker-input date-picker-input" type="text" [id]="id"
        readonly ngxDaterangepickerBootstrap [(ngModel)]="selectedRangeCalendarAutoLeft"
        [drops]="openUpward ? dropsUp : dropsDown" [opens]="opensRight" [locale]="locale" [ranges]="ranges"
        [showCustomRangeLabel]="true" [showCancel]="true" [linkedCalendars]="true" [alwaysShowCalendars]="true"
        [showRangeLabelOnInput]="false" [keepCalendarOpeningWithRange]="true" [closeOnAutoApply]="true"
        [autoApply]="true" [isTooltipDate]="isTooltipDate" [isCustomDate]="isCustomDates"
        [isInvalidDate]="isInvalidDate" (datesUpdated)="datesUpdatedRange($event)"
        (ngModelChange)="datesUpdatedRange($event); loadFetchFunctions()" [singleDatePicker]="false"
        [appOutSideClickDisabled]="false" appOutSideClick (outSideClick)="handleOutSideClick()" aria-describedby="novaRangeCalendarDesc" />
    </div>
  </div>
</div>
